import React, { useEffect, useState } from "react";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { elsevierStyleSheetJSfileImport } from "../library/utils";
import { Link, useNavigate, useLocation  } from "react-router-dom";
import Contact from "./Contact";
import EmailUs from "./EmailUs";
import Queries from "./Queries";

const Support = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [nav, setNav] = useState({ contact: true, email: false, faq: false });
  const [auth, setAuth] = useState(false);
  const [emailus] = useState(location.state?.emailus || "");

  useEffect(() => {
    authUser(); // Authenticate User
    elsevierStyleSheetJSfileImport();
    console.log("Support component mounted");
    console.log("emailus", emailus); // Debugging statement
    if (emailus) {
      changeScreen(emailus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNav = (event) => {
    event.preventDefault();
    const name = event.target.name;
    setNav({
      contact: name === "contact",
      email: name === "email",
      faq: name === "faq",
    });
  };

  const changeScreen = (screen) => {
    setNav({
      contact: screen === "call",
      email: screen === "mail",
      faq: false,
    });
  };


  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    if (token === null) {
      navigate("/");
      //} else {
      //  const valid = await validateJWTtoken(token);
      //  if (!valid) {
      //    navigate("/");
    } else {
      setAuth(true);
    }
    //}
  };

  if (!auth) {
    return <div></div>; // Optionally, show a loading indicator here
  }

  return (
    <React.Fragment>
      <MainHeader />
      <div className="container">
        <section>
          <div className="margin-top-30">
            <Link className="es-link colored font-16" to="/home">
              <svg viewBox="0 0 54 128" height="16" width="11">
                <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
              </svg>
              &nbsp;Back to home
            </Link>
          </div>
          <h3 className="margin-top-30">Elsevier Support Center</h3>
          <div className="row margin-top-30">
            <div className="col-2">
              <nav id="support-center">
                <ol className="es-list none">
                  <li>
                    <button
                      className={nav.contact ? "es-link selected pointer" : "es-link pointer"}
                      name="contact"
                      onClick={handleNav}
                    >
                      Contact Us
                    </button>
                  </li>
                  <li>
                    <button
                      className={nav.email ? "es-link selected pointer" : "es-link pointer"}
                      name="email"
                      onClick={handleNav}
                    >
                      Email Us
                    </button>
                  </li>
                  <li>
                    <button
                      className={nav.faq ? "es-link selected pointer" : "es-link pointer"}
                      name="faq"
                      onClick={handleNav}
                    >
                      FAQ and Videos
                    </button>
                  </li>
                </ol>
              </nav>
            </div>

            <div className="col-10">
              <div id="contact" className={nav.contact ? "" : "collapse"}>
                <Contact />
              </div>
              <div id="email" className={nav.email ? "" : "collapse"}>
                <EmailUs />
              </div>
              <div id="faq" className={nav.faq ? "" : "collapse"}>
                <Queries changeScreen={changeScreen} />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default Support;